import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import Errors from '../../notifications/Errors'
import { 
  ACCESS_DENIED_ACTION, 
} from './constants'

class AccessDenied extends Component {

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      errors: [],
    };

    this.backToHome = this.backToHome.bind();
    this.backToLogin = this.backToLogin.bind();
  }

  backToHome = () => {
    this.props.onClose();
    this.props.history.push('/dashboard');
  }

  backToLogin = () => {
    this.props.logoutClick();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.header.type == ACCESS_DENIED_ACTION){
      this.setState({
        errors: nextProps.header.errors,
      });
    }
    else {
      this.setState({
        errors: [],
      });
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isOpen} className={'modal-lg'}>
          <ModalBody>
              <Row>
                <Col md="12">
                {!!this.state.errors.length && (
                  <Errors message="Failure to signup due to:" errors={this.state.errors} />
                )}
                </Col>
              </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.backToHome}>Về trang chủ</Button>
            <Button color="secondary" onClick={this.backToLogin}>Đăng nhập với tài khoản khác</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default AccessDenied


// WEBPACK FOOTER //
// ./src/components/Header/_AccessDenied.js